import React from 'react';


export function ProposalLink(proposal) {
    return <a href={`/proposal/${proposal.id}`}>{proposal.title}</a>;
}
